import React from "react";
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function EmptyBasket() {
    return (
            <Container>
                <Row>
                    <Col className="mb-4">
                        <Alert variant="success" className="rounded-4">
                            <Alert.Heading>Ваша корзина пуста!</Alert.Heading>
                            <a href="/catalog" className="text-decoration-underline">Перейти в каталог товаров</a>
                        </Alert>
                    </Col>
                </Row>
            </Container>
    );
}

export default EmptyBasket;